import { create } from 'zustand';

type prevUrlStore = {
  prevUrl: string | undefined;
  setPrevUrl: (prevUrl: string) => void;
};

export const usePrevUrlStore = create<prevUrlStore>((set) => ({
  prevUrl: undefined,
  setPrevUrl(prevUrl) {
    set({ prevUrl });
  },
}));
